__turbopack_context__.v({
  "component": "header-search-module-scss-module__s_iLla__component",
  "locationInput": "header-search-module-scss-module__s_iLla__locationInput",
  "search-icon": "header-search-module-scss-module__s_iLla__search-icon",
  "suggested-location-dropdown": "header-search-module-scss-module__s_iLla__suggested-location-dropdown",
  "zoocasaTheme": "header-search-module-scss-module__s_iLla__zoocasaTheme",
});
